import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const PilotDashboardPreview = () => {
  return (
    <section className="py-24 bg-slate-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
              One Dashboard. <br />
              <span className="text-indigo-400">Infinite Visibility.</span>
            </h2>
            <p className="text-slate-400 text-lg mb-12 leading-relaxed">
              Pilot isn't just a setup tool—it's your ongoing operations hub. Manage attendee lists, monitor ticket velocity, and adjust schedules on the fly from any device.
            </p>
            <div className="space-y-8">
              {[
                { id: 1, title: "Calendar Intelligence", desc: "Instantly visualize workload with integrated Month, Week, and List views." },
                { id: 2, title: "Dynamic Ticketing", desc: "Pivot pricing and availability based on real-time demand signals." },
                { id: 3, title: "Global Sync", desc: "Ensure your whole team is aligned with Google Calendar synchronization." }
              ].map((step) => (
                <div key={step.id} className="flex items-start">
                  <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full bg-indigo-600 text-white font-bold border-2 border-indigo-500">
                    {step.id}
                  </div>
                  <div className="ml-6">
                    <h4 className="text-xl font-bold text-white mb-2">{step.title}</h4>
                    <p className="text-slate-400">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="bg-slate-800 rounded-3xl p-4 shadow-2xl border border-slate-700">
              <div className="bg-slate-900 rounded-2xl overflow-hidden border border-slate-800">
                {/* Mock UI Header */}
                <div className="p-4 border-b border-slate-800 flex justify-between items-center bg-slate-900/50">
                  <div className="flex gap-2">
                    <div className="w-3 h-3 rounded-full bg-red-500/50"></div>
                    <div className="w-3 h-3 rounded-full bg-yellow-500/50"></div>
                    <div className="w-3 h-3 rounded-full bg-green-500/50"></div>
                  </div>
                  <div className="flex gap-4">
                    <div className="h-4 w-20 bg-slate-800 rounded"></div>
                    <div className="h-4 w-4 bg-slate-800 rounded"></div>
                  </div>
                </div>
                {/* Mock Calendar UI */}
                <div className="p-6">
                  <div className="grid grid-cols-7 gap-2 mb-4">
                    {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map(d => (
                      <div key={d} className="text-[10px] text-slate-500 text-center font-bold">{d}</div>
                    ))}
                    {Array.from({ length: 31 }).map((_, i) => (
                      <div key={i} className={`h-10 rounded-lg flex items-center justify-center text-xs font-semibold ${i === 14 ? 'bg-indigo-600 text-white' : 'bg-slate-800/50 text-slate-400'}`}>
                        {i + 1}
                      </div>
                    ))}
                  </div>
                  <div className="space-y-3">
                    <div className="p-3 bg-indigo-500/10 border border-indigo-500/20 rounded-xl flex items-center gap-3">
                      <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
                      <div className="flex-1 h-2 bg-indigo-500/20 rounded"></div>
                    </div>
                    <div className="p-3 bg-emerald-500/10 border border-emerald-500/20 rounded-xl flex items-center gap-3">
                      <div className="w-2 h-2 rounded-full bg-emerald-500"></div>
                      <div className="flex-1 h-2 bg-emerald-500/20 rounded"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Background Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-indigo-500/20 blur-[100px] -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PilotDashboardPreview;